import LocalizedStrings from "react-localization";

let homePageStrings = new LocalizedStrings({
    en: {
        pageTitle: "Ludare",
        pageTagLine: "VOTE WITH YOUR WALLET",
        pageSubTagLine: "and support your favorite indies financially\nso they can continue to make games you love!",
        startButtonText: "Get Started",
        descTitle1: "DARE TO BE ",
        descTitle2: "INDIE",
        descText: "Ludare is a game subscription service meant to support indie developers based on the way you play their games. This helps players support in the ways they already love, by playing games, and developers be rewarded for doing what they like, developing and maintaining great games.",
        roleTitle1: "WHO ARE ",
        roleTitle2: "YOU?",
        playerRoleTitle: "PLAYER",
        playerRoleDesc: "For players, all you need to do is sign up, set up your payment, and then boot up any Ludare enabled game.We will automatically track your playtime during the month and then pay out your payments to the developers of the games you played.",
        playerRoleSelect: "I am a player!",
        devRoleTitle: "DEVELOPER",
        devRoleDesc: "For developers, we offer a simple plugin for major engines and common languages. Once integrated and maintained in the game, this plugin will track player account information and play habits, ensuring you earn money for every minute of playtime.",
        devRoleSelect: "I am a developer!",
        trailer: "VIEW TRAILER",
        learnMore: "LEARN MORE",
        signUp: "SIGN UP",
        login: "LOGIN",
        gamePreviewTitle1: "SUPPORTED",
        gamePreviewTitle2: "GAMES",
        gamePreviewLibrary: "VIEW FULL LIBRARY",
        gamePreviewSub: "MANAGE YOUR SUBSCRIPTION",
    },
});

export default homePageStrings;